{
  "actions": "操作",
  "activeStakes": "当前质押",
  "apy": "年化收益率",
  "claimNow": "立即领取",
  "claimRewards": "领取奖励",
  "claimRewardsFailed": "奖励领取失败。",
  "days": "天",
  "duration": "期限",
  "enterExaltAmount": "输入 EXALT 数量",
  "enterStakeAmount": "输入质押金额",
  "enterValidExaltAmount": "请输入有效的 EXALT 数量。",
  "enterValidStakeAmount": "请输入有效的质押金额。",
  "estimatedApr": "预估年化利率",
  "estimatedRewards": "预估奖励",
  "exaltStaking": "EXALT 质押",
  "insufficientBalance": "EXALT 余额不足。",
  "loading": "加载中...",
  "lockPeriod": "锁定期",
  "minimumStake": "最低质押量",
  "nextReward": "下次奖励",
  "noActiveStakesYet": "未找到当前质押仓位。",
  "noRewardHistory": "暂无奖励历史。",
  "pendingReward": "待领取奖励",
  "processing": "处理中...",
  "rewardHistory": "奖励历史",
  "rewardRate": "奖励利率",
  "rewardsClaimedSuccessfully": "奖励领取成功。",
  "rewardsEarned": "已获奖励",
  "securityNotice": "安全提示",
  "serverError": "服务器错误。",
  "sessionExpired": "会话已过期，请重新登录。",
  "stake": "质押",
  "stakeCompleted": "已完成",
  "stakeExalt": "质押 EXALT",
  "stakeHistory": "质押历史",
  "stakeNow": "立即质押",
  "stakingFailed": "质押失败。",
  "stakingSecurity1": "奖励将在后台验证后发放。",
  "stakingSecurity2": "提前解除质押可能适用相关规则。",
  "stakingSecurity3": "特殊情况可能需要所有者/管理员审批。",
  "stakingSecurity4": "处理前将验证区块链确认信息。",
  "stakingStartedSuccessfully": "质押已成功开始。",
  "stakingSubtitle": "质押 EXALT，安全赚取被动收益。",
  "stakingTitle": "EXALT 质押",
  "totalRewards": "总奖励",
  "totalStaked": "总质押量",
  "unavailable": "不可用",
  "unstake": "解除质押",
  "unstakeFailed": "解除质押失败。",
  "unstakeNow": "立即解除质押",
  "unstakedSuccessfully": "代币解除质押成功。"
}